import React from 'react';
import { CurrencyType } from '#components';
import { Button, Space } from '@bedrock/components';
import useQuotationDetailModal from '#features/useQuotationDetailModal';
import { ChevronRight } from '@bedrock/icons-react';

const PriceDetailModal = (props) => {
  const { demand_supplier_quote, detail, orderNum} = props;

  const { open: openQuotationDetailModal } = useQuotationDetailModal({
    detail,
  });

  const handleQuotationDetails = async () => {
    openQuotationDetailModal({
      index_id: orderNum,
      demand_supplier_id: demand_supplier_quote?.demand_supplier_id,
      cooperate_account_id: demand_supplier_quote?.cooperate_account_id,
    });
  };

  return (
    <div>
      <Space size={12} align='start'>
        <CurrencyType value={{ value: demand_supplier_quote?.discount_quote_price_with_tax, currency: demand_supplier_quote?.currency }} view currencyColor='black'/>
        <Button type='link' onClick={handleQuotationDetails} suffixIcon={<ChevronRight />}>报价详情</Button>
      </Space>
    </div >
  )
}

export default PriceDetailModal;
